// ABOUTME: Gives its children a way to open the slot picker to move one Nylas-booked session
// ABOUTME: Only when the session has a reschedule-session link; SessionChangeDialogs shows it
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { ReactNode } from 'react';
import { Link } from '../../Resource/Types';
import { sessionChangeStore } from './SessionChangeStore';

interface Props {
  rescheduleLink: Maybe<Link>;
  // What the opening page refreshes once a change succeeds; nothing when the platform's shared
  // events refresh is enough.
  refresh: Maybe<() => void>;
  children: (open: Maybe<() => void>) => ReactNode;
}

const RescheduleSession = ({ rescheduleLink, refresh, children }: Props) => (
  <>
    {children(
      rescheduleLink.map((link) => () => {
        sessionChangeStore.openReschedule(link, refresh);
      }),
    )}
  </>
);

export default observer(RescheduleSession);
